import {toHtml} from 'hast-util-to-html'
import {h} from 'hastscript'

export function htmlImage(alt: string, src: string, width?: number, height?: number): string {
  return toHtml(h('img', {src, alt, width, height}))
}
